import React, {
    useState, useEffect, useRef
} from 'react';

import {
    Send, Bot, User, X
} from 'lucide-react';

import axios from 'axios';
const SecurityChatbot = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [messages, setMessages] = useState([{
        id: 1, sender: 'bot', text: '¡Hola! Soy tu asistente de Inteligencia Artificial para Seguridad EHS. He revisado los registros de tu proyecto activo. ¿En qué te puedo ayudar hoy?'
    }]);
    const [input, setInput] = useState('');
    const [isTyping, setIsTyping] = useState(false);
    const messagesEndRef = useRef(null);
    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({
            behavior: "smooth"
        });
    };
    useEffect(() => {
        if (isOpen) {
            scrollToBottom();
        }
    }, [messages, isOpen]);
    const handleSend = async (e) => {
        e.preventDefault();
        if (!input.trim()) return;
        const userMsg = input.trim();
        setInput('');
        // Agregar mensaje del usuario
        setMessages(prev => [...prev, {
            id: Date.now(), sender: 'user', text: userMsg
        }]);
        setIsTyping(true);
        try {
            const projectId = localStorage.getItem('activeProjectId');
            const res = await axios.post('http://localhost:4000/api/ai/chat', {
                message: userMsg
            }, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')
                        }`, 'x-project-id': projectId
                }
            });
            // Agregar respuesta del bot
            setMessages(prev => [...prev, {
                id: Date.now(), sender: 'bot', text: res.data.reply
            }]);
        } catch (error) {
            console.error("Error comunicando con IA:", error);
            setMessages(prev => [...prev, {
                id: Date.now(), sender: 'bot', text: 'Ups, ocurrió un error al conectarme con mis servidores. Por favor intenta de nuevo.'
            }]);
        } finally {
            setIsTyping(false);
        }
    };
    if (!isOpen) {
        return (<button onClick={
            () => setIsOpen(true)
        } className="fixed bottom-6 right-6 bg-blue-600 hover:bg-blue-500 text-theme-text-primary p-4 rounded-full shadow-2xl shadow-blue-500/50 transition-all hover:scale-105 z-50 flex items-center justify-center animate-bounce-slow" > <Bot size={
            28
        } /> <span className="absolute -top-1 -right-1 bg-red-500 w-3.5 h-3.5 rounded-full border-2 border-gray-900 animate-pulse"></span> </button>);
    } return (<div className="fixed bottom-6 right-6 w-80 md:w-96 bg-theme-bg border border-theme-border rounded-2xl shadow-2xl z-50 flex flex-col overflow-hidden animate-in slide-in-from-bottom-5"> {
        /* Header */
    } <div className="bg-theme-panel border-b border-theme-border p-4 flex justify-between items-center"> <div className="flex items-center gap-3"> <div className="bg-blue-600/20 p-2 rounded-lg text-blue-400"> <Bot size={
        20
    } /> </div> <div> <h3 className="font-bold text-theme-text-primary text-sm">Asistente EHS</h3> <p className="text-xs text-green-400 flex items-center gap-1"> <span className="w-1.5 h-1.5 bg-green-500 rounded-full inline-block"></span> Online </p> </div> </div> <button onClick={
        () => setIsOpen(false)
    } className="text-theme-text-secondary hover:text-theme-text-primary transition-colors"> <X size={
        20
    } /> </button> </div> {
            /* Messages Area */
        } <div className="flex-1 p-4 overflow-y-auto max-h-96 min-h-[300px] flex flex-col gap-4 bg-theme-bg/50"> {
            messages.map((msg) => (<div key={
                msg.id
            } className={
                `flex gap-2 w-max max-w-[85%] ${msg.sender === 'user' ? 'ml-auto flex-row-reverse' : ''
                }`
            }> <div className={
                `p-2 rounded-lg 1flex-shrink-0 h-fit ${msg.sender === 'user' ? 'bg-blue-600 text-theme-text-primary' : 'bg-theme-panel text-blue-400 border border-theme-border'
                }`
            }> {
                        msg.sender === 'user' ? <User size={
                            16
                        } /> : <Bot size={
                            16
                        } />
                    } </div> <div className={
                        `p-3 rounded-xl text-sm ${msg.sender === 'user' ? 'bg-blue-600 text-theme-text-primary rounded-tr-none' : 'bg-theme-panel text-gray-200 border border-theme-border rounded-tl-none whitespace-pre-line'
                        }`
                    }> {
                        msg.text
                    } </div> </div>))
        } {
                isTyping && (<div className="flex gap-2 w-max max-w-[85%]"> <div className="p-2 rounded-lg bg-theme-panel text-blue-400 border border-theme-border flex-shrink-0 h-fit"> <Bot size={
                    16
                } /> </div> <div className="p-4 rounded-xl text-sm bg-theme-panel border border-theme-border rounded-tl-none flex items-center gap-1"> <span className="w-1.5 h-1.5 bg-gray-500 rounded-full animate-bounce [animation-delay:-0.3s]"></span> <span className="w-1.5 h-1.5 bg-gray-500 rounded-full animate-bounce [animation-delay:-0.15s]"></span> <span className="w-1.5 h-1.5 bg-gray-500 rounded-full animate-bounce"></span> </div> </div>)
            } <div ref={
                messagesEndRef
            } /> </div> {
            /* Input Area */
        } <form onSubmit={
            handleSend
        } className="bg-theme-panel p-3 border-t border-theme-border flex gap-2"> <input type="text" value={
            input
        } onChange={
            (e) => setInput(e.target.value)
        } placeholder="Pregunta sobre riesgos..." className="flex-1 bg-theme-bg border border-theme-border rounded-xl px-4 py-2 text-sm text-theme-text-primary focus:outline-none focus:border-blue-500 transition-colors" /> <button type="submit" disabled={
            !input.trim() || isTyping
        } className="bg-blue-600 hover:bg-blue-500 disabled:bg-gray-700 disabled:text-gray-500 text-theme-text-primary p-2 rounded-xl transition-colors flex flex-shrink-0 items-center justify-center" > <Send size={
            18
        } /> </button> </form> </div>);
};
export default SecurityChatbot;

